import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { XPhone } from '@swordhealth/ui'


export default /*@__PURE__*/_defineComponent({
  __name: 'SwordPhone',
  props: {
    value: {},
    error: {}
  },
  emits: ["input", "reset-form-feedback"],
  setup(__props: any, { emit: __emit }) {

/**
 * Bridge component: Vue 2 v-model (value/input) → Vue 3 XPhone (modelValue/update:modelValue)
 *
 * Required while using @vue/compat in MODE: 2.
 * Once compat is removed or MODE is set to 3 globally, delete this file
 * and map SwordPhoneWuk directly to XPhone in global-components.ts
 */
const props = __props

const emit = __emit

const handleUpdate = (newValue: string) => {
  if (props.error) {
    emit('reset-form-feedback')
  }

  emit('input', newValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(XPhone), _mergeProps(_ctx.$attrs, {
    "model-value": __props.value,
    "validation-triggers": { onBlur: true, onChange: true, onInput: true },
    "onUpdate:modelValue": handleUpdate
  }), null, 16, ["model-value"]))
}
}

})